/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedWasteRequest
 */
export interface APIPatchedWasteRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedWasteRequest
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedWasteRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the APIPatchedWasteRequest interface.
 */
export function instanceOfAPIPatchedWasteRequest(value: object): value is APIPatchedWasteRequest {
    return true;
}

export function APIPatchedWasteRequestFromJSON(json: any): APIPatchedWasteRequest {
    return APIPatchedWasteRequestFromJSONTyped(json, false);
}

export function APIPatchedWasteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedWasteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function APIPatchedWasteRequestToJSON(value?: APIPatchedWasteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'comment': value['comment'],
    };
}

